import type { GetDisclosureContentDTO } from '../service/ai-disclosure.repository.interface';
import type { GetDisclosureContentRequest, GetDisclosureContentResponse } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetDisclosureContent } from '@/infrastructure/api-functions/interface/get-disclosure-content.interface';

@injectable()
export class GetDisclosureContentDTOImpl implements GetDisclosureContentDTO {
    constructor(
        @inject(GetDisclosureContent)
        private readonly _getDisclosureContentApi: GetDisclosureContent,
    ) {
    }

    async fetch(value: GetDisclosureContentRequest): Promise<GetDisclosureContentResponse> {
        const params = {
            task_id: value.taskId,
            current_step: value.currentStep,
            content_type: value.contentType,
            text: value.text,
        };

        const res = await this._getDisclosureContentApi.GetDisclosureContent(params);
        return {
            content: res.content,
            status: res.status,
        };
    }
}
